/**
 * SubmissionStatusBadge Component
 * Displays submission status as a colored chip
 */

import React from 'react';
import { Chip } from '@mui/material';
import { SUBMISSION_STATUS_LABELS, SUBMISSION_STATUS_COLORS } from '../../utils/constants';

export const SubmissionStatusBadge = ({ status }) => {
  const label = SUBMISSION_STATUS_LABELS[status] || status;
  const color = SUBMISSION_STATUS_COLORS[status] || 'default';

  return (
    <Chip
      label={label}
      color={color}
      size="small"
      sx={{ fontWeight: 500 }}
    />
  );
};
